import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import RestaurantIcon from '@mui/icons-material/RestaurantMenu';
import MessageIcon from '@mui/icons-material/Message';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import FoodBankIcon from '@mui/icons-material/FoodBank';
import CampaignIcon from '@mui/icons-material/Campaign';
import GroupsIcon from '@mui/icons-material/Groups';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import MoneyIcon from '@mui/icons-material/AttachMoney';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import StorefrontIcon from '@mui/icons-material/Storefront';
import WorkIcon from '@mui/icons-material/Work';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import InsightsIcon from '@mui/icons-material/Insights';

import { ROUTE_ADVERTISEMENTS, ROUTE_COUPONS, ROUTE_CUSTOMERS, ROUTE_DELIVERY_NOTIFICATIONS, ROUTE_EMPLOYERS, ROUTE_EXPIRATION_PROMOTIONS, ROUTE_FOOD_PARTNER_ORDERS, ROUTE_FOOD_PARTNERS, ROUTE_NOTIFICATIONS, ROUTE_PODS, ROUTE_PRICE_LISTS, ROUTE_PRODUCERS, ROUTE_PRODUCT_PROMOTIONS, ROUTE_PRODUCTS, ROUTE_PROMOTION_CAMPAIGNS, ROUTE_RESERVATIONS, ROUTE_SALES_ANALYSIS, ROUTE_STORE_PROMOTION_SETTINGS, ROUTE_SUPPLIERS, ROUTE_THEFT_REGISTRIES, ROUTE_WAREHOUSE_DOCUMENTS, ROUTE_WAREHOUSE_REPORTS, ROUTE_WAREHOUSE_STOCKS } from '../../../core/constants';

export const SidebarListItems = () => {
    const location = useLocation();

    // a section is active also on its sub pages, e.g. pod details highlight the pods entry
    const isActive = (route) => location.pathname === route || location.pathname.startsWith(route + '/');

    const isPromotionActive = [ROUTE_PRODUCT_PROMOTIONS, ROUTE_EXPIRATION_PROMOTIONS, ROUTE_STORE_PROMOTION_SETTINGS, ROUTE_PROMOTION_CAMPAIGNS, ROUTE_COUPONS].some(isActive);
    const isWarehouseActive = [ROUTE_WAREHOUSE_STOCKS, ROUTE_FOOD_PARTNER_ORDERS, ROUTE_WAREHOUSE_DOCUMENTS, ROUTE_WAREHOUSE_REPORTS].some(isActive);
    const isNotificationActive = [ROUTE_NOTIFICATIONS, ROUTE_DELIVERY_NOTIFICATIONS].some(isActive);

    const [openPromotion, setOpenPromotion] = useState(isPromotionActive);
    const [openWarehouse, setOpenWarehouse] = useState(isWarehouseActive);
    const [openNotification, setOpenNotification] = useState(isNotificationActive);

    useEffect(() => {
        if (isPromotionActive) setOpenPromotion(true);
        if (isWarehouseActive) setOpenWarehouse(true);
        if (isNotificationActive) setOpenNotification(true);
    }, [isPromotionActive, isWarehouseActive, isNotificationActive]);

    return (
        <>
            <ListItem disablePadding>
                <ListItemButton component={ Link } to={ ROUTE_SALES_ANALYSIS } selected={ isActive(ROUTE_SALES_ANALYSIS) }>
                    <ListItemIcon>
                        <InsightsIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Analiza sprzedaży"/>
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton component={ Link } to={ ROUTE_PODS } selected={ isActive(ROUTE_PODS) }>
                    <ListItemIcon>
                        <StorefrontIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Punkty sprzedaży"/>
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton component={ Link } to={ ROUTE_PRODUCTS } selected={ isActive(ROUTE_PRODUCTS) }>
                    <ListItemIcon>
                        <RestaurantIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Produkty"/>
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton component={ Link } to={ ROUTE_PRODUCERS } selected={ isActive(ROUTE_PRODUCERS) }>
                    <ListItemIcon>
                        <FoodBankIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Producenci"/>
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton component={ Link } to={ ROUTE_FOOD_PARTNERS } selected={ isActive(ROUTE_FOOD_PARTNERS) }>
                    <ListItemIcon>
                        <LocalShippingIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Dostawcy"/>
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton component={ Link } to={ ROUTE_SUPPLIERS } selected={ isActive(ROUTE_SUPPLIERS) }>
                    <ListItemIcon>
                        <DeliveryDiningIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Zaopatrzeniowcy"/>
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton component={ Link } to={ ROUTE_EMPLOYERS } selected={ isActive(ROUTE_EMPLOYERS) }>
                    <ListItemIcon>
                        <WorkIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Pracodawcy"/>
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton component={ Link } to={ ROUTE_CUSTOMERS } selected={ isActive(ROUTE_CUSTOMERS) }>
                    <ListItemIcon>
                        <GroupsIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Użytkownicy"/>
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton component={ Link } to={ ROUTE_THEFT_REGISTRIES } selected={ isActive(ROUTE_THEFT_REGISTRIES) }>
                    <ListItemIcon>
                        <LocalPoliceIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Kradzieże"/>
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton component={ Link } to={ ROUTE_PRICE_LISTS } selected={ isActive(ROUTE_PRICE_LISTS) }>
                    <ListItemIcon>
                        <MoneyIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Ceny"/>
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton onClick={ () => setOpenPromotion(prevState => !prevState) }>
                    <ListItemIcon>
                        <CampaignIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Promocje"/>
                    { openPromotion ? <ExpandLess/> : <ExpandMore/> }
                </ListItemButton>
            </ListItem>
            <Collapse in={ openPromotion } timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItemButton sx={ { pl: 4 } } component={ Link } to={ ROUTE_PRODUCT_PROMOTIONS } selected={ isActive(ROUTE_PRODUCT_PROMOTIONS) }>
                        <ListItemIcon>
                            <ArrowRightIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Promocje produktowe"/>
                    </ListItemButton>
                    <ListItemButton sx={ { pl: 4 } } component={ Link } to={ ROUTE_EXPIRATION_PROMOTIONS } selected={ isActive(ROUTE_EXPIRATION_PROMOTIONS) }>
                        <ListItemIcon>
                            <ArrowRightIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Promocje na krótki termin przydatności"
                                      primaryTypographyProps={ { style: { whiteSpace: 'pre-wrap' } } }/>
                    </ListItemButton>
                    <ListItemButton sx={ { pl: 4 } } component={ Link } to={ ROUTE_STORE_PROMOTION_SETTINGS } selected={ isActive(ROUTE_STORE_PROMOTION_SETTINGS) }>
                        <ListItemIcon>
                            <ArrowRightIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Ustawienia promocji sklepowych"
                                      primaryTypographyProps={ { style: { whiteSpace: 'pre-wrap' } } }/>
                    </ListItemButton>
                    <ListItemButton sx={ { pl: 4 } } component={ Link } to={ ROUTE_PROMOTION_CAMPAIGNS } selected={ isActive(ROUTE_PROMOTION_CAMPAIGNS) }>
                        <ListItemIcon>
                            <ArrowRightIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Akcje promocyjne"/>
                    </ListItemButton>
                    <ListItemButton sx={ { pl: 4 } } component={ Link } to={ ROUTE_COUPONS } selected={ isActive(ROUTE_COUPONS) }>
                        <ListItemIcon>
                            <ArrowRightIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Kupony"/>
                    </ListItemButton>
                </List>
            </Collapse>
            <ListItem disablePadding>
                <ListItemButton onClick={ () => setOpenWarehouse(prevState => !prevState) }>
                    <ListItemIcon>
                        <WarehouseIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Magazyn"/>
                    { openWarehouse ? <ExpandLess/> : <ExpandMore/> }
                </ListItemButton>
            </ListItem>
            <Collapse in={ openWarehouse } timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItemButton sx={ { pl: 4 } } component={ Link } to={ ROUTE_WAREHOUSE_STOCKS } selected={ isActive(ROUTE_WAREHOUSE_STOCKS) }>
                        <ListItemIcon>
                            <ArrowRightIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Stany magazynowe"/>
                    </ListItemButton>
                    <ListItemButton sx={ { pl: 4 } } component={ Link } to={ ROUTE_FOOD_PARTNER_ORDERS } selected={ isActive(ROUTE_FOOD_PARTNER_ORDERS) }>
                        <ListItemIcon>
                            <ArrowRightIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Zamówienia do dostawców"
                                      primaryTypographyProps={ { style: { whiteSpace: 'pre-wrap' } } }/>
                    </ListItemButton>
                    <ListItemButton sx={ { pl: 4 } } component={ Link } to={ ROUTE_WAREHOUSE_DOCUMENTS } selected={ isActive(ROUTE_WAREHOUSE_DOCUMENTS) }>
                        <ListItemIcon>
                            <ArrowRightIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Dokumenty magazynowe"/>
                    </ListItemButton>
                    <ListItemButton sx={ { pl: 4 } } component={ Link } to={ ROUTE_WAREHOUSE_REPORTS } selected={ isActive(ROUTE_WAREHOUSE_REPORTS) }>
                        <ListItemIcon>
                            <ArrowRightIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Raporty"/>
                    </ListItemButton>
                </List>
            </Collapse>
            <ListItem disablePadding>
                <ListItemButton component={ Link } to={ ROUTE_RESERVATIONS } selected={ isActive(ROUTE_RESERVATIONS) }>
                    <ListItemIcon>
                        <ShoppingCartIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Rezerwacje"/>
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton onClick={ () => setOpenNotification(prevState => !prevState) }>
                    <ListItemIcon>
                        <MessageIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Powiadomienia"/>
                    { openNotification ? <ExpandLess/> : <ExpandMore/> }
                </ListItemButton>
            </ListItem>
            <Collapse in={ openNotification } timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItem disablePadding>
                        <ListItemButton sx={ { pl: 4 } } component={ Link } to={ ROUTE_NOTIFICATIONS } selected={ isActive(ROUTE_NOTIFICATIONS) }>
                            <ListItemIcon>
                                <ArrowRightIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Wysyłka powiadomień"/>
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton sx={ { pl: 4 } } component={ Link } to={ ROUTE_DELIVERY_NOTIFICATIONS } selected={ isActive(ROUTE_DELIVERY_NOTIFICATIONS) }>
                            <ListItemIcon>
                                <ArrowRightIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Wzory powiadomień o dostawach"
                                          primaryTypographyProps={ { style: { whiteSpace: 'pre-wrap' } } }/>
                        </ListItemButton>
                    </ListItem>
                </List>
            </Collapse>
            <ListItem disablePadding>
                <ListItemButton component={ Link } to={ ROUTE_ADVERTISEMENTS } selected={ isActive(ROUTE_ADVERTISEMENTS) }>
                    <ListItemIcon>
                        <LiveTvIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Reklamy"/>
                </ListItemButton>
            </ListItem>
        </>
    );
};

export default SidebarListItems;
